var InFlight = InFlight || {};

InFlight.xamarin = (function () {
    // Polling settings (in milliseconds) for when verifying if the xamarin app exists in isXamarinAvailable
    var pollingInterval = 100;
    var pollingTimeout = 4500;

    var appAvailable;
    var awaitingLoginResponse = false;

    var permissions = {
        CAMERA: "camera",
        STORAGE_WRITE: "storageWrite",
        STORAGE_READ: "storageRead",
        LOCATION_WHEN_IN_USE: "locationWhenInUse",
        LOCATION_ALWAYS: "locationAlways"
    };

    var isXamarinReady = function () {
        return new Promise(function (resolve, reject) {
            var timeSpent = 0;
            var interval = setInterval(function() {
                timeSpent += pollingInterval;
                if (typeof window.xamarinAllCallbacksReady === "function") {
                    appAvailable = true;
                    clearInterval(interval);
                    resolve();
                }
                else if (timeSpent >= pollingTimeout) {
                    appAvailable = false;
                    clearInterval(interval);
                    reject();
                }
            }, pollingInterval);
        });    
    }

    var login = function(user, pass) {
        if (typeof window.xamarinLogin === "function") {
            window.xamarinLogin(JSON.stringify({
                user: user,
                pass: pass
            }));
            awaitingLoginResponse = true;
        }
    }  

    var awaitLoginSuccess = function() {
        if (awaitingLoginResponse) {
            loginSuccess(true, '', '');
            awaitingLoginResponse = false;
        }
    }

    var loginSuccess = function(status, user, pass) {
        if (typeof window.xamarinLoginSuccess === "function") {
            window.xamarinLoginSuccess(JSON.stringify({
                user: user,
                pass: pass,
                status: status
            }));
        }
    }    

    var loginReady = function() {
        if (typeof window.xamarinLoginReady === "function") {
            window.xamarinLoginReady('true');
        }
    }

    var showInViewer = function(path) {
        if (typeof window.xamarinFileViewer === "function" && path) {
            window.xamarinFileViewer(path);
        }
    }

    var openExternal = function(url, application) {
        if (typeof window.xamarinOpenExternal === "function" && url) {
            if (!application) {
                application = 'browser';
            }
            window.xamarinOpenExternal(JSON.stringify({
                url: url,
                application: application
            }));
        }        
    }    
    
    var hasBioAuth = function() {
        if (typeof window.xamarinHasBioAuth === "function") {
            return true;
        } else {
            return false;
        }
    }

    var resetBioAuth = function() {
        if (typeof window.xamarinResetBioAuth === "function") {
            window.xamarinResetBioAuth("true");
        }
    }    

    var sendAppLink = function(title, description, xid) {
        if (typeof window.xamarinAppLink === "function") {
            var payload = {
                title: title,
                description: description,
                xid: xid,
                url: window.location.href
            };
            window.xamarinAppLink(JSON.stringify(payload));
        }
    } 

    var isAppAvailable = function() {
        if  (appAvailable !== undefined) {
            return appAvailable;
        } else {
            return (typeof window.xamarinAllCallbacksReady === "function");
        }
    }

    var requestPermission = function (requestType) {
        if (typeof window.xamarinRequestPermission === "function") {
            if (typeof requestType === "string") {
                requestType = [requestType];
            }
            var payload = {
                types: requestType
            };
            window.xamarinRequestPermission(JSON.stringify(payload));
        }
    }

    var isAndroid = function () {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if (/android/i.test(userAgent)) {
            return true;
        }
        return false;        
    }

    return {
        isXamarinReady: isXamarinReady,
        login: login,
        loginSuccess: loginSuccess,
        awaitLoginSuccess: awaitLoginSuccess,
        loginReady: loginReady,
        showInViewer: showInViewer,
        openExternal: openExternal,
        hasBioAuth: hasBioAuth,
        resetBioAuth: resetBioAuth,
        sendAppLink: sendAppLink,
        requestPermission: requestPermission,
        isAppAvailable: isAppAvailable,
        isAndroid: isAndroid,
        permissions: permissions
    };
})();
